import { render, staticRenderFns } from "./PainelSetup.vue?vue&type=template&id=bd3f519e&scoped=true&"
import script from "./PainelSetup.vue?vue&type=script&lang=js&"
export * from "./PainelSetup.vue?vue&type=script&lang=js&"
import style0 from "./PainelSetup.vue?vue&type=style&index=0&id=bd3f519e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3f519e",
  null
  
)

export default component.exports